import fsaSlice from "../slices/fsaSlice";

export const {
  RequestCdrList,
  SuccessCdrList,
  FailureCdrList,
  RequestFsaCount,
  SuccessFsaCount,
  FailureFsaCount,
  RequestFsaAnalysisStatistics,
  SuccessFsaAnalysisStatistics,
  FailureFsaAnalysisStatistics,
  RequestAddApplication,
  SuccessAddApplication,
  FailureAddApplication,
  RequestFsaApplications,
  SuccessFsaApplications,
  FailureFsaApplications,
  RequestEditApplication,
  SuccessEditApplication,
  FailureEditApplication,
  RequestDeleteApplication,
  SuccessDeleteApplication,
  FailureDeleteApplication,
} = fsaSlice.actions;
